import React, { useContext, useState } from 'react';
import chartArrowIcon from '../../images/sideMenu/arrow_drop_down.svg';
import { MenuContext } from '../../context/MenuContext';
import { PAGE_TYPE } from '../../constants';
import { ReportContext } from '../../context/ReportContext';

const MenuBlock = ({ title, titleIcon, items, rootClass, defaultExpanded = false }) => {
    const [submenuVisible, setSubmenuVisible] = useState(defaultExpanded);
    const { selectedMenuItem, setSelectedMenuItem, isMenuOpen } = useContext(MenuContext);
    const { setSelectedReportBySlug } = useContext(ReportContext);

    const minWidth = { minWidth: isMenuOpen ? '225px' : '40px' };

    // Sorry for this ugliness - will go away once the current page SOT is a proper router
    const handleClick = (item) => {
        setSelectedMenuItem(item);
        if (item.pageType === PAGE_TYPE.reports) {
            setSelectedReportBySlug(item.slug);
        }
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div className={rootClass} style={minWidth}>
            <div
                className="menu-title-container"
                onClick={() => setSubmenuVisible((x) => !x)}
            >
                {titleIcon}
                {isMenuOpen && (
                    <>
                        <p className="menu-title">{title}</p>
                        <img
                            src={chartArrowIcon}
                            alt="Arrow"
                            className={`arrow-icon ${submenuVisible ? 'expanded' : ''}`}
                        />
                    </>
                )}
            </div>
            <div className={`submenu-container ${submenuVisible ? 'expanded' : ''}`}>
                {items.map((item, idx) => (
                    <div key={item.slug || `${title}-${idx}`}>
                        <div
                            className="menu-item-container"
                            onClick={() => handleClick(item)}
                        >
                            {item.icon}
                            {isMenuOpen && (
                                <p
                                    className={`ml-2 menu-item`}
                                    style={{
                                        fontWeight:
                                            selectedMenuItem.slug === item.slug
                                                ? 'bold'
                                                : 'unset',
                                    }}
                                >
                                    {item.name}
                                </p>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default MenuBlock;
